import { benefits } from "./benefits";
import { body } from "./body";
import { features } from "./features";
import { featureTabs } from "./featureTabs";
import { header } from "./header";
import { promoSection } from "./promoSection";
import { statCounterWidget } from "./statCounterWidget";
import { trendingJobs } from "./trendingJobs";
import { tileGroups } from "./tileGroups";
import { promotionalCarousel } from "./promotionalCarousel";
import { multiTiles } from "./multiTiles";
import { multiCards } from "./multiCards";
import { chatbot } from "./chatbot";

export const snippets = {
  benefits,
  body,
  features,
  featureTabs,
  header,
  promoSection,
  statCounterWidget,
  trendingJobs,
  tileGroups,
  promotionalCarousel,
  multiTiles,
  multiCards,
  chatbot,
};

export default snippets;

export {
  benefits,
  body,
  features,
  featureTabs,
  header,
  promoSection,
  statCounterWidget,
  trendingJobs,
  tileGroups,
  promotionalCarousel,
  multiTiles,
  multiCards,
  chatbot,
};
